// utils/tokenValidator.ts

/**
 * Decodifica um JWT sem verificar a assinatura
 * (apenas para ler o payload e verificar expiração)
 */
export const decodeJWT = (token: string): any | null => {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }

    // Decodifica o payload (segunda parte)
    const payload = JSON.parse(atob(parts[1]));
    return payload;
  } catch (error) {
    console.error('Erro ao decodificar JWT:', error);
    return null;
  }
};

/**
 * Verifica se o token JWT está expirado
 * @param token - Token JWT
 * @returns true se expirado, false caso contrário
 */
export const isTokenExpired = (token: string): boolean => {
  const payload = decodeJWT(token);

  if (!payload || !payload.exp) {
    // Se não conseguir decodificar ou não tiver campo 'exp', considera expirado
    return true;
  }

  // exp está em segundos, Date.now() em milissegundos
  const expirationTime = payload.exp * 1000;
  const currentTime = Date.now();

  return currentTime >= expirationTime;
};

/**
 * Valida se um token é válido (existe e não está expirado)
 * @param token - Token JWT ou null
 * @returns true se válido, false caso contrário
 */
export const isTokenValid = (token: string | null): boolean => {
  if (!token) {
    return false;
  }

  return !isTokenExpired(token);
};
